import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Typeahead from './Typeahead';
import { TYPEAHEAD_LIMIT } from '../../../containers/App/constants';

const VisualisationContainer = styled.div`
  margin-top: 20px;
  position: relative;
`;

class Visualisation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      suggestions: this.props.controlList.Options[`${this.props.kidAdult}List`]
        .slice(0, TYPEAHEAD_LIMIT)
        .filter((v) => (v.slideAvailable))
        .map(({ nicename, visualisationId: id }) => ({
          text: nicename,
          value: id,
        })),
    };
  }
  onChange(value, acceptPartial) {
    const vis = this.checkValid(value, acceptPartial);
    if (vis) {
      this.setState({
        value: vis.text,
      });
      this.props.storeVisualisation(`Slide${vis.value}`);
    } else if (this.props.storedVisualisation !== '') {
      this.props.storeVisualisation('');
    }
  }
  getSuggestions(text) {
    const controlList = this.props.controlList;
    const regex = fuzzyRegex(text);
    const vis = controlList.Options[`${this.props.kidAdult}List`].filter((v) => regex.test(`${v.visualisationId}: ${v.nicename}`)).slice(0, TYPEAHEAD_LIMIT).filter((v) => (v.slideAvailable));
    this.setState({
      suggestions: vis.map(({ nicename, visualisationId: id }) => ({
        text: nicename,
        value: id,
      })),
    });
  }
  checkValid(value, acceptPartial) {
    if (value.length > 0) {
      let vis = this.state.suggestions.filter((s) =>
        value === s.text
      );

      if (vis.length === 0 && acceptPartial) {
        const regex = fuzzyRegex(value);
        vis = this.state.suggestions.filter((s) =>
          regex.test(s.text)
        );
      }

      if (vis.length === 1) {
        return vis[0];
      }
    }
    return false;
  }
  render() {
    return (
      <VisualisationContainer>
        <h4>Visualisation</h4>
        <Typeahead
          value={this.state.value}
          suggestions={this.state.suggestions}
          getSuggestions={(text) => this.getSuggestions(text)}
          onChange={(v, a) => this.onChange(v, a)}
        />
      </VisualisationContainer>
    );
  }
}

function fuzzyRegex(text) {
  const tarray = text.split(' ');
  return new RegExp(tarray.join('.*'), 'i');
}

Visualisation.propTypes = {
  controlList: PropTypes.object,
  kidAdult: PropTypes.string,
  storeVisualisation: PropTypes.func,
  storedVisualisation: PropTypes.string,

};

export default Visualisation;



// WEBPACK FOOTER //
// ./app/components/FormControls/Visualisation/index.js